import {useState} from "react";
import {toast} from "react-toastify";
import {getUrl} from "../../../constants/urls";
import Call from "../../../service/axios";
import {generateQueryUrl} from "../../../helpers/generateQueryUrl";

export const useInventoryReportsExport = (tokens) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (format) => {
    setIsExporting(true);
    try {
      const baseUrl = getUrl("inventoryReportsExport");
      const filterUrl = generateQueryUrl(baseUrl, tokens);
      const separator = tokens?.length > 0 ? "&" : "?";
      const url = `${filterUrl}${separator}export_format=${format}`;

      const response = await Call.get(url, {
        responseType: "blob",
      });

      const fileName =
        format === "pdf" ? "inventory_reports.pdf" : "inventory_reports.csv";

      const blob = new Blob([response.data]);
      const downloadUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = downloadUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      URL.revokeObjectURL(downloadUrl);
    } catch {
      toast.error("Export failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const exportCSV = () => handleExport("csv");
  const exportPDF = () => handleExport("pdf");

  return {exportCSV, exportPDF, isExporting};
};
